// App.jsx (corrigido para Leadsv2.jsx)
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import PoliticaPrivacidade from "./pages/PoliticaPrivacidade";
import ResetSenha from "./pages/ResetSenha"; // ✅ já existe
import ForgotSenha from "./pages/ForgotSenha"; // ✅ NOVO (crie o arquivo)

import LayoutComMenu from "./LayoutComMenu";
import RotaPrivada from "./Components/RotaPrivada";
import LeadPrintPage from "./Components/LeadPrintPage";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFilaNotificacoes } from "./utils/useFilaNotificacoes";
import CentralNotificacoesToast from "./utils/centralNotificacoes";

import CaptaZap from "./modules/captazap/CaptaZap";
import DashboardMulticanal from "./modules/captazap/components/DashboardMulticanal";
import DashboardPrincipal from "./pages/DashboardPrincipal";
import ChatPage from "./modules/captazap/components/ChatPage";
import FluxoCaixa from "./pages/FluxoCaixa";

// IMPORTS DOS PROVIDERS!
import { AuthProvider } from "./context/AuthContext";
import { EmpresaProvider } from "./context/EmpresaContext";

// IMPORTS LEADS
import Leads from "./pages/Leads";
import LeadsV2 from "./pages/Leadsv2.jsx"; // ⬅️ v minúsculo para coincidir com o nome real

export default function App() {
  const { fila, pushNotification, removerNotificacao } = useFilaNotificacoes();

  // Dados fake para teste da tela de chat
  const fakeMinhasConversas = [
    { id: 1, nome: "João", numero: "11999999999", preview: "Olá!" },
  ];
  const fakeFilaDeEspera = [
    {
      id: 2,
      nome: "Maria",
      numero: "11988888888",
      preview: "Preciso de ajuda.",
    },
  ];
  const fakeContatos = [
    { id: 3, nome: "Lucas", numero: "11977777777", preview: "Bom dia!" },
  ];

  return (
    <EmpresaProvider>
      <AuthProvider>
        <Router>
          <>
            <Routes>
              {/* ✅ Rotas públicas */}
              <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
              <Route path="/login" element={<Login />} />
              <Route path="/imprimir-leads" element={<LeadPrintPage />} />

              {/* ✅ ESQUECI SENHA (PÚBLICA) — tela para pedir o email */}
              <Route path="/forgot-senha" element={<ForgotSenha />} />

              {/* ✅ RESET SENHA (PÚBLICA) — tem que ficar ANTES do "*" */}
              <Route path="/reset-senha" element={<ResetSenha />} />

              {/* Rotas protegidas com menu */}
              <Route
                path="*"
                element={
                  <RotaPrivada>
                    <LayoutComMenu pushNotification={pushNotification} />
                  </RotaPrivada>
                }
              >
                <Route index element={<DashboardPrincipal />} />
                <Route path="dashboard" element={<DashboardPrincipal />} />

                {/* Leads (V1) e Leads V2 */}
                <Route path="leads" element={<Leads />} />
                <Route path="leads-v2" element={<LeadsV2 />} />

                <Route
                  path="chat"
                  element={
                    <ChatPage
                      minhasConversas={fakeMinhasConversas}
                      filaDeEspera={fakeFilaDeEspera}
                      contatos={fakeContatos}
                    />
                  }
                />
                <Route path="fluxo-caixa" element={<FluxoCaixa />} />
              </Route>

              {/* Rota separada para dashboard multicanal (sem menu) */}
              <Route
                path="/dashboard-multicanal"
                element={
                  <DashboardMulticanal
                    stats={{
                      whatsapp: 12,
                      instagram: 5,
                      telegram: 3,
                      facebook: 2,
                      email: 1,
                    }}
                  />
                }
              />
            </Routes>

            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar={false}
              closeOnClick
              pauseOnHover
              draggable
              newestOnTop
            />

            <CentralNotificacoesToast
              fila={fila}
              removerNotificacao={removerNotificacao}
            />
          </>
        </Router>
      </AuthProvider>
    </EmpresaProvider>
  );
}
